import {
  Button,
  CardContent,
  Grid,
  TextField,
  makeStyles,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { toast } from 'react-toastify';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import html2canvas from 'html2canvas';
import { localizationTable, options } from 'constants/table';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AttendanceData } from 'services/dataService';
import FileSaver from 'file-saver';
import MaterialTable, { MTableToolbar } from 'material-table';
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CertificateData } from 'services/dataService';

const StudentCertificatesOffline = () => {
  const classes = useStyles();
  const tableRef = useRef();
  const [modalStatus, setModalStatus] = useState(false);
  const [modalExam, setModalExam] = useState(false);
  const [enrollment, setEnrollment] = useState(null);
  const [data, setData] = useState();
  const [filter, setFilter] = useState({
    name: '',
    status: 2,
  });
  const { id } = useSelector((state) => state.auth);
  const { register, handleSubmit, control } = useForm();
  const { t } = useTranslation([
    'label',
    'toastify',
    'tables',
    'form',
    'button',
    'validation',
    'message',
  ]);

  const filterTable = useCallback((filter) => {
    getData(filter);
  });

  const getData = async (filter) => {
    const attendance = await AttendanceData.getAttendanceProfileDataById(id, filter);
    setData(attendance?.data?.report);
  };

  const handleDownloadCertificate = useCallback(async (rowData) => {
    try {
      toast.success(t('toastify:commons.toast_success_certificate'));
      const secondPageCanvas = await html2canvas(document.getElementById('certificate-second-page'), {
        scale: 2,
        useCORS: true,
      });
      const secondPageImage = secondPageCanvas.toDataURL('image/png');

      const requestBody = {
        id_attendance: rowData?.id_attendance,
        id_user: id,
        certificate_create_date: rowData?.finished_at,
        secondPageImage,
      };

      const { data: base64CertificateFile } = await CertificateData.downloadOffline(
        rowData?.company_course,
        requestBody
      );

      const responsePDF = await fetch(base64CertificateFile);
      const blob = await responsePDF.blob();
      FileSaver.saveAs(blob, `${rowData?.course_attendance}.pdf`);

    } catch (error) {
      console.error('Erro ao gerar o certificado:', error);
    }
  }, []);

  useEffect(() => {
    getData();
  }, []);


  const getStatus = useCallback(
    (value) => {
      if (value)
        return (
          <div className={classes.status}>
            <Brightness1Icon
              fontSize="small"
              color="primary"
              style={{ marginRight: 5 }}
            />
            {t('label:commons.label_status_active')}
          </div>
        );
      else
        return (
          <div className={classes.status}>
            <Brightness1Icon
              color="secondary"
              fontSize="small"
              style={{ marginRight: 5 }}
            />
            {t('label:commons.label_status_inactive')}
          </div>
        );
    },
    [t]
  );

  return (
    <div>
      <div
        id="certificate-second-page"
        style={{
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
          display: 'none',
          width: '1366px',
          height: '768px',
          padding: '25px',
          boxSizing: 'border-box',
          background: '#fff',
          fontFamily: 'Arial, sans-serif',
          fontSize: '16px',
          color: '#000',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <h2 style={{ display: 'none', textAlign: 'center', fontWeight: 'bold', marginBottom: '20px', marginLeft: '20px' }}>
            Conteúdo Programático
          </h2>

          <div style={{ display: 'flex', gap: '40px' }}>
            {/* {columns.map((col, idx) => (
              <div key={idx} style={{ flex: 1 }}>
                {col.map((module, i) => (
                  <div key={i} style={{ marginBottom: '20px', breakInside: 'avoid' }}>
                    <strong style={{ display: 'block', marginBottom: '4px' }}>
                      {module.title}
                    </strong>
                    {module.lessons.map((lesson, j) => (
                      <div key={j} style={{ fontSize: '14px', lineHeight: '1.6', marginLeft: '10px' }}>
                        Aula {lesson.order?.toString().padStart(2, '0')} – {lesson.title}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))} */}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
        </div>
      </div>
      <MaterialTable
        title={`${t('button:User.btn_profile_courses_not_online_cert')}`}
        tableRef={tableRef}
        columns={[
          {
            title: `${'Curso'}`, field: 'course'
          },
          {
            title: `${'Treinamento'}`, field: 'course_attendance'
          },
          {
            title: `${'Início'}`, field: 'start_at'
          },
          {
            title: `${'Final'}`, field: 'finished_at',
          },
          {
            title: `${'Instrutor'}`, field: 'instructor'
          },
          {
            title: `${'Carga Horária'}`, field: 'workload'
          },
        ]}
        data={data}
        actions={[
          (rowTable) => {
            return {
              icon: 'download',
              tooltip: `${t('button:Course.btn_download_certificate')}`,
              onClick: (_, rowData) => handleDownloadCertificate(rowData),
              iconProps: {
                color: 'primary',
              },
            };
          },
        ]}
        components={{
          search: false,
          title: true,
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <CardContent>
                <form onSubmit={handleSubmit(filterTable)}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        defaultValue={''}
                        variant="outlined"
                        name="name"
                        inputRef={register({ required: false })}
                        label={'Treinamento'}
                      />
                    </Grid>
                    <Grid item xs={12} md={1} />
                    <Grid item xs={12} md={5} className={classes.actions}>
                      <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        type="submit"
                      >
                        <Search style={{ marginRight: '5px' }} />
                        {t('button:commons.btn_advanced_filter')}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </div>
          ),
        }}
        localization={localizationTable(t)}
        options={options}
      />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  status: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
}));

export default StudentCertificatesOffline;